import React, { useState, useEffect } from "react";
import api from "../../utils/axiosConfig";
import "../../styles/groupDetails/IndexingProgress.css";

const IndexingProgress = ({ groupId, canUpload }) => {
  const [status, setStatus] = useState(null);
  const [showCompletion, setShowCompletion] = useState(false);

  useEffect(() => {
    if (!canUpload || !groupId) return;

    let pollInterval = null;
    let completionTimeout = null;

    const fetchStatus = async () => {
      try {
        const res = await api.get(`/media/group/${groupId}/indexing-status`);
        const data = res.data;
        setStatus(data);

        // Stop polling if complete
        if (data.complete) {
          if (pollInterval) clearInterval(pollInterval);
          if (data.total > 0 && data.processed === data.total) {
            setShowCompletion(true);
            completionTimeout = setTimeout(() => setShowCompletion(false), 3000);
          }
        }
      } catch (err) {
        console.error("Error fetching indexing status:", err);
      }
    };

    // Initial fetch
    fetchStatus();

    // Poll every 3 seconds
    pollInterval = setInterval(() => {
      fetchStatus();
    }, 3000);

    return () => {
      if (pollInterval) clearInterval(pollInterval);
      if (completionTimeout) clearTimeout(completionTimeout);
    };
  }, [groupId, canUpload]);

  if (!canUpload || !status || status.total === 0) return null;

  if (status.complete && !showCompletion) return null;

  const progressPercent = status.total > 0 ? (status.processed / status.total) * 100 : 0;

  return (
    <div className="indexing-progress-container">
      <div className="indexing-progress-header">
        <span className="indexing-progress-title">
          {status.complete ? "Face AI Processing Complete ✅" : "Face AI Processing"}
        </span>
        {!status.complete && (
          <span className="indexing-progress-stats">
            {status.processed} / {status.total} processed ({status.pending} remaining)
          </span>
        )}
      </div>
      {!status.complete && (
        <div className="indexing-progress-bar-bg">
          <div
            className="indexing-progress-bar-fill"
            style={{ width: `${progressPercent}%` }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default IndexingProgress;